import type { TenantID } from '../../cross-app-shared/types/db';

export const complianceNavigationFace: 'compliance' | 'parsing' = /parsing/i.test(window.location.origin)
  ? 'parsing'
  : 'compliance';
export const systemName = 'Compliance Tool';
// We assume all Compliance Tool URLs are prefixed with the tenant ID:
const firstPartOfRoute = new URL(window.location.href).pathname.split('/')[1] || '0';
export const tenantID: TenantID = (/^\d+$/.test(firstPartOfRoute) ? Number(firstPartOfRoute) : 0) as TenantID;
